import { useContext } from "react";
import { useMutation } from "react-query";
import { ApiContext } from "../../contexts/ApiContext";
import { WorkOrderResultUpload } from "../../shared/interfaces/Result";
import { QueryCallbacks } from "../../shared/interfaces/ReactQuery";

export function useWorkOrderResultFileUpload(callbacks?: QueryCallbacks<void>) {
  const apiContext = useContext(ApiContext);
  return useMutation(
    ["uploadWorkOrderResultFile"],
    async (workOrderResultUpload: WorkOrderResultUpload) =>
      apiContext.resultsApis.uploadWorkOrderResultFile(workOrderResultUpload),
    {
      onSuccess: callbacks?.onSuccess,
      onError: callbacks?.onError,
    },
  );
}
